import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/favicon.png'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 sticky-top" }
const _hoisted_3 = { class: "navbar navbar-expand-sm navbar-light" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "40",
  height: "40",
  class: "d-inline-block align-text-top"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_7 = {
  class: "collapse navbar-collapse justify-content-end",
  id: "navbarSupportedContent"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "mt-10" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12\"><div style=\"height:6rem;background-color:#BADA55;\"></div></div><footer class=\"footer\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"><h2>GRUPO SAFEGUARD</h2><p>Chetumal, México</p><p>Email: gruposafeguard@gmail.com</p><p>Tel: 983 454 00 25</p></div><div class=\"col-md-6\"><h2>¿Cómo podemos ayudarte?</h2><form><div class=\"row\"><div class=\"form-group col-md-6\"><input type=\"text\" class=\"form-control\" placeholder=\"Nombre\" required></div><div class=\"form-group col-md-6\"><input type=\"text\" class=\"form-control\" placeholder=\"Apellido\" required></div></div><div class=\"row\"><div class=\"form-group col-md-6\"><input type=\"tel\" class=\"form-control\" placeholder=\"Teléfono\" required></div><div class=\"form-group col-md-6\"><input type=\"email\" class=\"form-control\" placeholder=\"Email\" required></div></div><div class=\"form-group\"><textarea class=\"form-control\" placeholder=\"Escribe tu mensaje aquí...\" rows=\"4\" required></textarea></div><button type=\"submit\" class=\"btn btn-block\">Enviar</button></form></div></div></div></footer>", 2)

import routesName from '@/app/utils/routes';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const router = useRouter();
const routes = computed(() => {
    return router.options.routes.filter(route => route.meta && route.meta.show);
});
const currentRouteName = computed(() => router.currentRoute.value.name);
const goHome = () => {
    router.push({ name: routesName.home });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "navbar-brand",
            onClick: goHome
          }, [
            _hoisted_5,
            _createTextVNode(" Grupo SafeGuard ")
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: route.name,
                to: route.path,
                class: "nav-item active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(route.meta!.realname), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _hoisted_10
  ]))
}
}

})